export const table = {
    wrapper: {
        style: {
            borderRadius: "8px",
            margin: '20px',
            boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
            backgroundColor: '#ffffff',
            padding: '20px'
        },
    },
    header: {
        gap: "middle",
        justify: "space-between",
        wrap: "wrap",
        width:'280px'
    },

    selectTable: {
        style: { width: "250px" },
        placeholder: "Select a form",
    },
    title: {
        style: {
            backgroundColor: '#F7F7F7',
            borderRadius: 8,
            cursor: 'pointer',
            marginBottom: 10,
            padding: '10px 20px',
            transition: 'background-color 0.3s ease',
        }
    }
}